import {useState} from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import { deepOrange } from "@material-ui/core/colors";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import ProfileModal from "./profileModal"
import {auth} from "../firebase"

const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  usernameIcon: {
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  menu: {
    marginTop: 30
  }
}));

function AvatarContent() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));

  const logout = async () => {
    handleClose()
    await auth.signOut()
    window.location.href = "/"
  }

  return (
    <>
    <Grid item xs={2} md={2} className={classes.usernameIcon}>
      <Avatar
        className={classes.orange}
        onClick={handleClick}
      >
        {currentUser.fullName.substring(0, 1)}
      </Avatar>
    </Grid>
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      className={classes.menu}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <MenuItem onClick={() => {
        setModalOpen(true)
        setAnchorEl(null)
      }}>Profile</MenuItem>
      <MenuItem onClick={logout}>Logout</MenuItem>
    </Menu>
    {modalOpen && <ProfileModal setOpen={setModalOpen}/>}
    </>
  );
}

export default AvatarContent;
